import { useMutation } from '@apollo/client/react';
import { datadogRum } from '@datadog/browser-rum';
import { useAuth } from '@teamexos/fit-shared';
import { useEffect } from 'react';
import { usePageVisibility } from 'react-page-visibility';
import { App, UpdateLastActivityDocument } from '../graphql/types';
import logger from '../utils/logger';

export default function useLastActivity() {
  const [updateLastActivityMutation] = useMutation(UpdateLastActivityDocument);
  const { isRegistrationComplete } = useAuth();
  const isVisible = usePageVisibility();

  useEffect(() => {
    const triggerLastActivity = async () => {
      try {
        if (!isRegistrationComplete || !isVisible) {
          return;
        }
        logger.debug('LAST ACTIVITY SAVED', { app: App.Heart });
        await updateLastActivityMutation();
      } catch (err) {
        datadogRum.addError(err);
      }
    };

    triggerLastActivity();
  }, [updateLastActivityMutation, isRegistrationComplete, isVisible]);
}
